import { Button, WideAlert, Icons } from '@components';
import React from 'react';
import './styles.css';
import { mdiCommentAlertOutline } from '@mdi/js';
import { Link, useNavigate } from 'react-router-dom';
import { SIMULADOR_RESGATE_PARCIAL } from '../../../../common/utils/paths';

export const TermosResgateSimulacao = ({ setViewTerms }) => {
  const navigate = useNavigate();
  return (
    <>
      <WideAlert className="mb-4" iconClear={false}>
        <div className="d-block d-lg-flex align-items-center">
          <Icons
            path={mdiCommentAlertOutline}
            color="var(--primary-color)"
            size={4}
            style={{ marginRight: 18 }}
          />
          <p className="ts-16">
            <strong>Aviso importante:</strong> este é o formulário para
            solicitar o Resgate Parcial de seu saldo de contas. Caso tenha
            dúvidas,{' '}
            <Link to={SIMULADOR_RESGATE_PARCIAL}>faça uma simulação </Link>
            ou entre em contato com a nossa Central de Atendimento pelo 0800 090
            90 90.
          </p>
        </div>
      </WideAlert>

      <div className="card">
        <div className="card-body">
          <h2>
            <strong>Solicitação do Resgate Parcial</strong>
          </h2>
          <div className="terms">
            <p className="description">
              O Resgate Parcial do plano de previdência permite ao participante
              receber uma porcentagem dos valores aportados ainda durante a fase
              de acumulação.
            </p>
            <p className="description">
              Ao optar pelo Resgate Parcial, você estará fazendo uma escolha{' '}
              <b>irreversível e irretratável</b>, que terá impacto no valor
              final do seu benefício futuro.
            </p>
            <p className="description">
              <b>Faça uma avaliação cuidadosa antes de tomar esta decisão.</b>{' '}
              Em caso de dúvidas,
              <Link to={SIMULADOR_RESGATE_PARCIAL}>
                faça uma simulação
              </Link>{' '}
              para entender melhor as consequências desta medida ou entre em
              contato com a nossa Central de Atendimento, pelo 0800 090 90 90.
            </p>
            <p className="description">
              Para fazer sua solicitação, será obrigatório escolher seu regime
              de tributação: Progressivo ou Regressivo. São diversos fatores a
              se considerar para a escolha do regime tributário, como, por
              exemplo: renda; tempo restante para acumulação e entrada em
              benefício mensal; se existem outras fontes de renda; gastos
              dedutíveis para imposto de renda (despesas médicas, educação
              etc.); desenvolvimento da vida profissional com reflexo na
              remuneração, entre outros.
            </p>
            <p className="description">
              Importante lembrar que a escolha é manifestada neste momento, mas
              seu reflexo é, além de aplicado no Resgate Parcial, repercutido em
              todo o benefício recebido até o exaurimento dos recursos, visto
              que se torna DEFINITIVA. Recomendamos que você busque mais
              informações sobre o assunto antes de fazer sua opção.
            </p>
            <p className="description">
              Confira os vídeos e matérias abaixo mais detalhes sobre este
              processo.
            </p>
            <p className="description">
              <a
                href="https://institucional.forluz.org.br/noticias-internas/CNPC-50---Perguntas-Frequentes-(FAQ)=&Id=2047"
                target="_blank"
                rel="noreferrer"
              >
                Perguntas Frequentes
              </a>
            </p>
            <p className="description">
              <a
                href="https://youtu.be/4nQjW4u1xFA"
                target="_blank"
                rel="noreferrer"
              >
                Tutorial Resgate Parcial
              </a>{' '}
            </p>
            <p className="description">
              <a
                href="https://youtu.be/rIuXkjMchts "
                target="_blank"
                rel="noreferrer"
              >
                Entenda os Regimes de Tributação
              </a>
            </p>
            <p className="description">
              Siga os próximos passos para formalizar seu pedido do Resgate
              Parcial de seu saldo de contas.
            </p>
          </div>

          <div className="tbrow" />
          <br />
          <div className="tbbutton gap-4">
            <Button
              transparent
              color="orange"
              className="max-180 "
              onClick={() => navigate(-1)}
            >
              Voltar
            </Button>
            <Button className="max-180" onClick={() => setViewTerms(false)}>
              Iniciar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
